<template lang='pug' src='./contact-us.pug'></template>

<script>
import Loader from 'components/loader/loader'
import VueTrigger from 'components/block/block-vue-trigger/block-vue-trigger'
import MainForm from 'components/form/form'
import Hero from 'components/hero/hero'
import Icon from 'components/icon/icon'
import TextBox from 'components/block/block-text-box/block-text-box'
import ImgBox from 'components/block/block-img-box/block-img-box'
import SimpleButton from 'components/block/block-simple-button/block-simple-button'
import FunctionButton from 'components/block/block-function-button/block-function-button'
import RouterButton from 'components/block/block-router-button/block-router-button'
import HeaderSection from 'components/block/block-header-section/block-header-section'
import ParallaxSection from 'components/block/block-parallax-section/block-parallax-section'
import TileSection from 'components/custom/custom-tile-repeater/custom-tile-repeater'
import PercentSection from 'components/custom/custom-percent-section/custom-percent-section'
import ContactSection from 'components/custom/custom-contact-section/custom-contact-section'
import ContactForm from 'components/custom/custom-contact-form/custom-contact-form'

export default {
  name: 'contact-us',
  computed: {
    props () {
      return this.$store.state.pages['contact-us']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  methods: {
    navScrolled () {
      this.$store.dispatch('VIEW_NAV', true)
    },
    notScrolled () {
      this.$store.dispatch('VIEW_NAV', false)
    }
  },
  components: {
    Loader,
    VueTrigger,
    MainForm,
    Hero,
    Icon,
    TextBox,
    ImgBox,
    SimpleButton,
    FunctionButton,
    RouterButton,
    HeaderSection,
    ParallaxSection,
    TileSection,
    PercentSection,
    ContactSection,
    ContactForm
  }
}
</script>



// WEBPACK FOOTER //
// contact-us.vue?1c9dcc09